export function generateRoutePath(path, params) {
    if (path.toString() === '/')
        return path;
    var splittedPath = path.split('/').slice(1);
    var result = '';
    for (var _i = 0, splittedPath_1 = splittedPath; _i < splittedPath_1.length; _i++) {
        var segment = splittedPath_1[_i];
        if (segment.startsWith(':')) {
            var key = segment.slice(1);
            var parsedKey = typeof key === 'string' ? key.split('?')[0] : key;
            if (params[parsedKey]) {
                result += "/".concat(params[parsedKey]);
            }
        }
        else {
            result += "/".concat(segment);
        }
    }
    return result;
}
export function generateDialogRoutePath(path, params) {
    var splittedPath = path.split('/');
    var result = '';
    for (var _i = 0, splittedPath_2 = splittedPath; _i < splittedPath_2.length; _i++) {
        var segment = splittedPath_2[_i];
        if (segment.startsWith('#')) {
            result += "".concat(segment);
        }
        else if (segment.startsWith(':')) {
            var key = segment.slice(1);
            var parsedKey = typeof key === 'string' ? key.split('?')[0] : key;
            if (params[parsedKey]) {
                result += "/".concat(params[parsedKey]);
            }
        }
        else {
            result += "/".concat(segment);
        }
    }
    return result;
}
export var RoutePath;
(function (RoutePath) {
    RoutePath["ROOT"] = "/";
    RoutePath["COMING_SOON"] = "/coming-soon";
    RoutePath["SIGN_IN"] = "/sign-in";
    RoutePath["SIGN_IN_JWT"] = "/sign-in-jwt";
    RoutePath["SIGN_UP"] = "/sign-up";
    RoutePath["RESET_PASSWORD"] = "/reset-password";
    RoutePath["ACCOUNT"] = "/account/:tab";
    RoutePath["ACCOUNT_TRANSFER"] = "/account-transfer";
    RoutePath["INIT_WALLET"] = "/init-wallet";
    RoutePath["TRANSFER_ASSETS_MPC"] = "/transfer-assets";
    RoutePath["CUSTOM_WALLET"] = "/custom-wallet";
    RoutePath["SHOP"] = "/shop/:tab";
    RoutePath["SHOP_SERIE"] = "/shop/serie/:id";
    RoutePath["BRIDGE"] = "/bridge/:bridgeType/:contractType";
    RoutePath["MARKET"] = "/market/:section/:tab";
    RoutePath["PRODUCT"] = "/market/product/:type/:id/:tab";
    RoutePath["ASSET"] = "/market/asset/:tokenId/:tab";
    RoutePath["MY_ASSETS"] = "/my-assets/:section/:tab";
    RoutePath["MY_ASSETS_FLEX"] = "/my-assets-flex";
    RoutePath["MANAGE_TOKENS"] = "/manage-tokens/:tab";
    RoutePath["VIP_PROGRAM"] = "/vip-program/:tab";
    RoutePath["STAKING"] = "/staking/:tab";
    RoutePath["STAKING_CREATE"] = "/new-staking";
    RoutePath["STAKING_EXTEND"] = "/extend-staking";
    RoutePath["STAKING_FILL"] = "/fill-staking";
    RoutePath["PENDING_BURNS"] = "/pending-burns";
    RoutePath["PENDING_BURN"] = "/pending-burn/:uuid";
    RoutePath["PENDING_USES"] = "/pending-uses";
    RoutePath["PENDING_USE"] = "/pending-use/:uuid";
    RoutePath["CHANGELOG"] = "/changelog/:tab";
    RoutePath["FEEDBACK"] = "/feedback/:tab?";
    RoutePath["PAYMENT_SUCCESS"] = "/payment-success";
    RoutePath["CLAIM_TOKEN"] = "/claim-token";
    RoutePath["CRAFT_RESULT"] = "/crafted/:id";
    RoutePath["SANDBOX"] = "/sandbox";
})(RoutePath || (RoutePath = {}));
export var DialogRoutePath;
(function (DialogRoutePath) {
    DialogRoutePath["CRAFT"] = "#craft/:ian";
})(DialogRoutePath || (DialogRoutePath = {}));
export var AccountTab;
(function (AccountTab) {
    AccountTab["OVERVIEW"] = "overview";
    AccountTab["MY_INFO"] = "my-info";
    AccountTab["WALLETS"] = "wallets";
    AccountTab["TRANSACTIONS"] = "transactions";
    AccountTab["TOOLS"] = "tools";
})(AccountTab || (AccountTab = {}));
export var ShopTab;
(function (ShopTab) {
    ShopTab["CARDS"] = "cards";
    ShopTab["LANDS"] = "lands";
})(ShopTab || (ShopTab = {}));
export var MarketSection;
(function (MarketSection) {
    MarketSection["CARDS"] = "cards";
    MarketSection["MINT_PASSES"] = "mint-passes";
    MarketSection["LANDS"] = "lands";
    MarketSection["ARISE"] = "arise";
})(MarketSection || (MarketSection = {}));
export var MarketTab;
(function (MarketTab) {
    MarketTab["PRODUCTS"] = "products";
    MarketTab["ITEMS"] = "items";
    MarketTab["ACTIVITIES"] = "activities";
})(MarketTab || (MarketTab = {}));
export var MarketDetailsTab;
(function (MarketDetailsTab) {
    MarketDetailsTab["OVERVIEW"] = "overview";
    MarketDetailsTab["ON_SALE"] = "on-sale";
    MarketDetailsTab["DETAILS"] = "details";
    MarketDetailsTab["ACTIVITY"] = "activity";
})(MarketDetailsTab || (MarketDetailsTab = {}));
export var MyAssetsTab;
(function (MyAssetsTab) {
    MyAssetsTab["ALL"] = "all";
    MyAssetsTab["ON_SALE"] = "on-sale";
    MyAssetsTab["OFFERS"] = "offers";
    MyAssetsTab["HISTORY"] = "history";
})(MyAssetsTab || (MyAssetsTab = {}));
export var ManageTokensTab;
(function (ManageTokensTab) {
    ManageTokensTab["BUY"] = "buy";
    ManageTokensTab["TRANSFER"] = "transfer";
    ManageTokensTab["BRIDGE"] = "bridge";
    ManageTokensTab["HISTORY"] = "history";
})(ManageTokensTab || (ManageTokensTab = {}));
export var VipProgramTab;
(function (VipProgramTab) {
    VipProgramTab["MY_PERKS"] = "my-perks";
    VipProgramTab["HISTORY"] = "history";
    VipProgramTab["INFORMATION"] = "information";
})(VipProgramTab || (VipProgramTab = {}));
export var StakingTab;
(function (StakingTab) {
    StakingTab["OVERVIEW"] = "overview";
    StakingTab["MY_STAKINGS"] = "my-stakings";
    StakingTab["INFORMATION"] = "information";
})(StakingTab || (StakingTab = {}));
export var ChangelogTab;
(function (ChangelogTab) {
    ChangelogTab["TCG"] = "tcg";
    ChangelogTab["ARISE"] = "arise";
})(ChangelogTab || (ChangelogTab = {}));
export var FeedbackTab;
(function (FeedbackTab) {
    FeedbackTab["QUESTION"] = "question";
    FeedbackTab["REPRESENTATIVE"] = "representative";
    FeedbackTab["PORTAL"] = "portal";
})(FeedbackTab || (FeedbackTab = {}));
